import Vue from 'vue'
import './registerServiceWorker'

// Third party global libraries
import 'reflect-metadata'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Transitions from 'vue2-transitions';

// Modules
import { RouterModule } from '@/modules/router'
import NotFoundComponent from '@/modules/site/components/NotFoundComponent.vue'
import { StoreModule } from '@/modules/store'
import { CoreModule } from '@/modules/core'
import { SiteModule } from '@/modules/site'
import { PartnersModule } from '@/modules/partners'

// Service
import { ApiService } from './modules/core/services/api'
import { TokenService } from './modules/core/services/auth/token.service'
import { User } from '@/modules/core/models'
import { UserService } from '@/modules/partners/services/user.service'
import { ChatbotModule } from '@/modules/chatbot'
import { ProfileModule } from '@/modules/profile'

function boostrap () {
  Vue.config.productionTip = false;
  Vue.use(Transitions);

  if (process.env.VUE_APP_IS_PROD === true) { // add sentry on prod
    Sentry.init({
      dsn: 'https://92746380716d4dae8d4236f81be90ade@sentry.io/1804728',
      integrations: [new Integrations.Vue({ Vue, attachProps: true })]
    })
  }

  function installModules () {
    // add modules
    const routerModule = new RouterModule()
    routerModule.install(Vue)

    const storeModule = new StoreModule()
    storeModule.install(Vue)

    const coreModule = new CoreModule(routerModule.router!, storeModule.store!)
    coreModule.install(Vue)

    const siteModule = new SiteModule(routerModule.router!, storeModule.store!)
    siteModule.install(Vue)

    const partnersModule = new PartnersModule(routerModule.router!, storeModule.store!)
    partnersModule.install(Vue)

    const chatbotModule = new ChatbotModule(routerModule.router!, storeModule.store!)
    chatbotModule.install(Vue)

    const profileModule = new ProfileModule(routerModule.router!, storeModule.store!)
    profileModule.install(Vue)

    return routerModule
  }

  const routerModule = installModules()

  // initialize api
  ApiService.init(process.env.VUE_APP_API_BACKEND_URL)
  // Add default route
  routerModule.router.addRoutes([{ path: '*', component: NotFoundComponent }])
}

boostrap()
